var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1851 6.67816C15.0268 4.67857 12.8619 3.33325 10.3823 3.33325C7.57094 3.33325 5.16405 5.06271 4.17028 7.51439M14.1505 7.51439H17.5V4.16948M4.64823 13.368C5.80651 15.3676 7.97144 16.7129 10.451 16.7129C13.2624 16.7129 15.6693 14.9834 16.6631 12.5317M6.68283 12.5317H3.33333V15.8767",
    stroke: "#2D3036",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncRefresh);
export default __webpack_public_path__ + "static/media/sync_refresh.ca5af13648b7846a0117eb98ececf95c.svg";
export { ForwardRef as ReactComponent };